import messagesFr from './locales/fr'
import messagesApiFr from './locales/apiLocale/apiFr'
import messagesEn from './locales/en'
import messagesApiEn from './locales/apiLocale/apiEn'
import messagesDe from './locales/de'
import messagesApiDe from './locales/apiLocale/apiDe'
import messagesEs from './locales/es'
import messagesApiEs from './locales/apiLocale/apiEs'
import messagesIt from './locales/it'
import messagesApiIt from './locales/apiLocale/apiIt'
import messagesPl from './locales/pl'
import messagesApiPl from './locales/apiLocale/apiPl'
import { flatten } from 'flat'

export const fr = flatten({ ...messagesFr , ...messagesApiFr })
export const en = flatten({ ...messagesEn , ...messagesApiEn })
export const de = flatten({ ...messagesDe , ...messagesApiDe })
export const es = flatten({ ...messagesEs , ...messagesApiEs })
export const it = flatten({ ...messagesIt , ...messagesApiIt })
export const pl = flatten({ ...messagesPl , ...messagesApiPl })



// WEBPACK FOOTER //
// ./src/messages.js